import { Checkbox, FormControl, FormControlLabel, FormGroup, Typography } from '@mui/material'
import css from './MultipleChoiceQuestion.module.css'

const MultipleChoiceQuestion = ({ question, optional, options, value = [], onChange }) => {
  const handleChange = (option) => {
    const currentValues = Array.isArray(value) ? value : []
    const isSelected = currentValues.includes(option)

    const newValues = isSelected
      ? currentValues.filter(v => v !== option)
      : [...currentValues, option]

    onChange(newValues)
  }

  return (
    <div className={css.question}>
      <Typography className={css.title} variant="h5">
        {question} {optional && <span className={css.optional}>(opcional)</span>}
      </Typography>
      <div className={css.checkboxes}>
        <FormControl>
          <FormGroup>
            {options.map(option => (
              <FormControlLabel
                key={option}
                control={
                  <Checkbox
                    checked={Array.isArray(value) && value.includes(option)}
                    onChange={() => handleChange(option)}
                  />
                }
                label={option}
              />
            ))}
          </FormGroup>
        </FormControl>
      </div>
    </div>
  )
}

export default MultipleChoiceQuestion
